import React, { useState, useEffect } from "react";
import { fetchOffers } from "../services/api";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import "react-loading-skeleton/dist/skeleton.css";
import { motion } from "framer-motion";
import OfferCard from "./ui/OfferCard";

const Offer = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getOffers = async () => {
      try {
        const data = await fetchOffers(0);
        setOffers(data.payload.page.slice(0, 3)); // Only get first 3 offers for landing page
      } catch (error) {
        console.error("Failed to fetch offers:", error);
        setOffers([]);
      } finally {
        setLoading(false);
      }
    };

    getOffers();
  }, []);

  const OfferSkeleton = () => (
    <div className="col-lg-4 col-md-6 mb-4">
      <div className="project-card style1-1">
        <div className="project-card-img">
          <Skeleton height={250} />
        </div>
        <div className="project-card-details">
          <h4 className="box-title">
            <Skeleton width={200} />
          </h4>
          <Skeleton width={150} style={{ marginBottom: "8px" }} />
        </div>
      </div>
    </div>
  );

  return !loading && offers.length <= 0 ? (
    <>
      <></>
    </>
  ) : (
    <>
      <section className="project-sec space-top space-extra-bottom">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="row justify-content-center"
          >
            <div className="col-xl-6 col-lg-7 col-md-8">
              <div className="title-area text-center">
                {/* <span className="sub-title6">OUR OFFERS</span> */}
                <h2 className="sec-title">Featured Offers</h2>
              </div>
            </div>
          </motion.div>
          <div className="row gy-4">
            {loading ? (
              [...Array(3)].map((_, index) => <OfferSkeleton key={index} />)
            ) : (
              <>
                {offers.map((item, index) => {
                  return <OfferCard key={item.id} item={item} index={index} />;
                })}
                <motion.div
                  className="col-12 text-center mt-4"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.8 }}
                >
                  <Link to="/offers" className="th-btn">
                    View All Offers <i className="fas fa-arrow-right ms-2"></i>
                  </Link>
                </motion.div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Offer;
